"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KetteArtNrSplitter = void 0;
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
var SplittedArtNrOffsets;
(function (SplittedArtNrOffsets) {
    SplittedArtNrOffsets[SplittedArtNrOffsets["Breitenindex"] = 0] = "Breitenindex";
    SplittedArtNrOffsets[SplittedArtNrOffsets["Biegeradius"] = 1] = "Biegeradius";
    // Rbr is included in Biegeradius and separated with '/'
    SplittedArtNrOffsets[SplittedArtNrOffsets["Color"] = 2] = "Color";
    SplittedArtNrOffsets[SplittedArtNrOffsets["Material"] = 3] = "Material";
})(SplittedArtNrOffsets || (SplittedArtNrOffsets = {}));
/**
 * The `KetteArtNrGenerator` has the responsibility to
 * parse ArtNr and split it into seperate parts.
 */
class KetteArtNrSplitter {
    constructor() {
        this.className = 'KetteArtNrSplitter';
    }
    /**
     * Retrieves the serieKuerzel string of an ArtNr.
     */
    extractSerieKuerzel(artNrCountry, kette) {
        const ketteArtNr = this.getKetteArtNr(artNrCountry, kette);
        if (!ketteArtNr)
            return undefined;
        return this.getSplittedArtNr(artNrCountry, kette).serieKuerzel;
    }
    /**
     * Retrieves the color string of an ArtNr.
     */
    extractColor(artNrCountry, kette) {
        const ketteArtNr = this.getKetteArtNr(artNrCountry, kette);
        if (!ketteArtNr)
            return undefined;
        return this.getSplittedArtNr(artNrCountry, kette).color;
    }
    /**
     * Retrieves the material string of an ArtNr.
     */
    extractMaterial(artNrCountry, kette) {
        const ketteArtNr = this.getKetteArtNr(artNrCountry, kette);
        if (!ketteArtNr)
            return undefined;
        return this.getSplittedArtNr(artNrCountry, kette).material;
    }
    getKetteArtNr(artNrCountry, kette) {
        var _a, _b;
        return (_a = kette.artNr) !== null && _a !== void 0 ? _a : (_b = kette.localizedArtNr) === null || _b === void 0 ? void 0 : _b[artNrCountry];
    }
    /**
     * universal way to get correct artNr-specific "serieRef.kuerzel" to display in our frontend!
     * needs to be done this way, cause there are "artNr"'s which differ to the corresponding "serieRef.kuerzel" !
     * we also need to take care of mismatching leading-zeros.. kette.indexBreite and its part in kette.artNr
     * f.e.: "020" and E2i.15.20.048.0
     */
    getSplittedArtNr(artNrCountry, kette) {
        const ketteArtNr = this.getKetteArtNr(artNrCountry, kette);
        if (!ketteArtNr) {
            throw new Error(`${this.className}.getSplittedArtNr: Kette has no artNr`);
        }
        if (!kette.indexBreite) {
            throw new Error(`${this.className}.getSplittedArtNr: Kette has no indexBreite`);
        }
        if (!kette.indexBiegeradius) {
            throw new Error(`${this.className}.getSplittedArtNr: Kette has no indexBiegeradius`);
        }
        // helper function, will remove leading zeros from a given string
        const removeLeadingZero = (s) => {
            while (s && s !== '0' && s.startsWith('0')) {
                s = s.substring(1);
            }
            return s;
        };
        let separator = echain_shared_i18n_1.LocaleUtil.getArtNrSeparator(artNrCountry);
        // 'TRE' series use '.' separator for both locales
        const artNrIncludesSeperator = ketteArtNr.indexOf(separator) !== -1;
        if (!artNrIncludesSeperator) {
            separator = echain_shared_i18n_1.LocaleUtil.getDefaultArtNrSeparator();
        }
        const separatorAndPlus = `${separator}+`;
        const artNrIncludesPlus = ketteArtNr.indexOf(separatorAndPlus) !== -1;
        const artNrIncludesSlash = ketteArtNr.indexOf('/') !== -1;
        // split ketteArtNr in its parts, to reassemble them later on..
        const splittedArtNr = ketteArtNr.split(separator);
        // do the same, but remove leading zeros!
        const splittedArtNrWoLeadingZeros = splittedArtNr.map(removeLeadingZero);
        // lets build a artNr without leading zeros
        const artNrWoLeadingZeros = splittedArtNrWoLeadingZeros.join(separator);
        // build the universal splitter, to get our serieKuerzel
        let artNrSplitterWoLeadingZeros = `${separator}${removeLeadingZero(kette.indexBreite)}${separator}${removeLeadingZero(kette.indexBiegeradius)}`;
        if (!artNrWoLeadingZeros.includes(removeLeadingZero(kette.indexBiegeradius))) {
            throw new Error('KetteArtNrSplitter.getSplittedArtNr: invalid Kette-object! (unconsistent indexBiegeRadius)');
        }
        if (!artNrWoLeadingZeros.includes(removeLeadingZero(kette.indexBreite))) {
            throw new Error('KetteArtNrSplitter.getSplittedArtNr: invalid Kette-object! (unconsistent indexBreite)');
        }
        // add the slash only if the indexBiegeradius doesn't contain it
        if (artNrIncludesSlash && kette.indexBiegeradius.indexOf('/') === -1 && kette.indexBreite.indexOf('/') === -1) {
            artNrSplitterWoLeadingZeros += '/';
        }
        // split and get our serieKuerzel without leading zeros
        const serieKuerzelWoLeadingZeros = artNrWoLeadingZeros.split(artNrSplitterWoLeadingZeros)[0];
        // lets count how many parts serieKuerzel takes, to use offset later on to cherry-pick..
        const serieKuerzelCount = serieKuerzelWoLeadingZeros.split(separator).length;
        let biegeRadius = splittedArtNr[serieKuerzelCount + SplittedArtNrOffsets.Biegeradius];
        let rbr;
        // rbr present? should be if there is a '/' ..
        if (biegeRadius && biegeRadius.includes('/')) {
            // extract Rbr
            const splittedBiegeradius = biegeRadius.split('/');
            biegeRadius = splittedBiegeradius[0];
            rbr = splittedBiegeradius[1];
        }
        const serieKuerzel = splittedArtNr.slice(0, serieKuerzelCount).join(separator);
        const breitenIndex = splittedArtNr[serieKuerzelCount + SplittedArtNrOffsets.Breitenindex];
        const color = splittedArtNr[serieKuerzelCount + SplittedArtNrOffsets.Color];
        if (!serieKuerzel)
            throw new Error('KetteArtNrSplitter.getSplittedArtNr: invalid serieKuerzel');
        if (!biegeRadius)
            throw new Error('KetteArtNrSplitter.getSplittedArtNr: invalid biegeRadius');
        if (!breitenIndex)
            throw new Error('KetteArtNrSplitter.getSplittedArtNr: invalid breitenIndex');
        if (!color)
            throw new Error('KetteArtNrSplitter.getSplittedArtNr: invalid color');
        // building the splitted result..
        return {
            serieKuerzel,
            breitenIndex,
            biegeRadius,
            rbr,
            color,
            material: splittedArtNr[serieKuerzelCount + SplittedArtNrOffsets.Material + (artNrIncludesPlus ? 1 : 0)],
        };
    }
}
exports.KetteArtNrSplitter = KetteArtNrSplitter;
//# sourceMappingURL=KetteArtNrSplitter.js.map